module.exports = __webpack_public_path__ + "img/path-112.0a07067a.png";